import type { PageMeta } from '../types';

const defaultMeta: PageMeta = {
  titleKey: 'page-meta.dashboard.title',
  subtitleKey: 'page-meta.dashboard.subtitle',
};

/**
 * Resolves current pathname to page title/subtitle translation keys.
 * Uses a configurable route map so each app can define its own routes.
 */
export function getPageMeta(
  pathname: string,
  locale: string,
  routeMap: Record<string, PageMeta>,
): PageMeta {
  const withoutLocale = pathname.replace(`/${locale}`, '') || '/';

  for (const [route, meta] of Object.entries(routeMap)) {
    if (route === '/') {
      if (withoutLocale === '/') return meta;
    } else if (withoutLocale.startsWith(route)) {
      return meta;
    }
  }

  return defaultMeta;
}
